import React from 'react';
import { StatusIndicator } from '@amzn/awsui-components-react-v3';

export const StatusIcon = (status) => {
  let lowercaseStatus = '';
  if (typeof status === 'string') {
    lowercaseStatus = status.toLowerCase();
  } else {
    lowercaseStatus = status['status'];
    if (typeof lowercaseStatus === 'string') {
      lowercaseStatus = lowercaseStatus.toLowerCase();
    }
  }
  switch (lowercaseStatus) {
    case 'succeeded':
      return <StatusIndicator type={'success'}>Success</StatusIndicator>;

    case 'ready':
      return <StatusIndicator type={'success'}>Ready</StatusIndicator>;

    case 'active':
      return <StatusIndicator type={'success'}>Active</StatusIndicator>;

    case 'available':
      return <StatusIndicator type={'success'}>Associated</StatusIndicator>;

    case 'failed':
      return <StatusIndicator type={'error'}>Failed</StatusIndicator>;

    case 'aborted':
      return <StatusIndicator type={'error'}>Failed</StatusIndicator>;

    case 'pending':
      return <StatusIndicator type={'pending'}>Pending</StatusIndicator>;

    case 'initiated':
      return <StatusIndicator type={'pending'}>Initiated</StatusIndicator>;

    case 'waiting':
      return <StatusIndicator type={'pending'}>Waiting</StatusIndicator>;

    case 'inactive':
      return <StatusIndicator type={'stopped'}>Inactive</StatusIndicator>;

    case 'timeout':
      return <StatusIndicator type={'warning'}>Timeout</StatusIndicator>;

    case 'running':
      return <StatusIndicator type={'in-progress'}>Running</StatusIndicator>;

    case 'approved':
      return <StatusIndicator type={'success'}>Approved</StatusIndicator>;

    case 'denied':
      return <StatusIndicator type={'error'}>Denied</StatusIndicator>;

    case 'canceled':
      return <StatusIndicator type={'stopped'}>Canceled</StatusIndicator>;

    case 'approve':
      return <StatusIndicator type={'success'}>APPROVE</StatusIndicator>;

    case 'deny':
      return <StatusIndicator type={'error'}>DENY</StatusIndicator>;

    case 'needsmoredata':
      return <StatusIndicator type={'warning'}>NEEDS_MORE_DATA</StatusIndicator>;

    case 'completed':
      return <StatusIndicator type={'success'}>COMPLETED</StatusIndicator>;

    default:
      return <StatusIndicator type={'warning'}>Unknown</StatusIndicator>;
  }
};
